import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { IIndirectTaxLocationsResponse } from './types';

export function useIndirectTaxLocations({
  corporationId,
  includeServingRules = false,
  token,
}: {
  corporationId?: number;
  includeServingRules?: boolean;
  token?: string;
}) {
  const query = new URLSearchParams();
  if (includeServingRules) {
    query.append('include_serving_rules', 'true');
  }

  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data?: IIndirectTaxLocationsResponse;
    error?: unknown;
    isLoading: boolean;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    corporationId ? `new-sales-tax/locations/${corporationId}?${query}` : null,
    SWRFetcher({ method: 'GET' }, token)
  );

  return {
    locations: data?.locations ?? [],
    count: data?.count ?? 0,
    error,
    isLoading,
    mutate,
  };
}
